<template>
    <div class="container">

        <h2>Create a new voucher</h2>
        <table>
            <tr>
                <th>Code</th>
                <th>Value</th>
                <th>Description</th>
                <th>Expiration date</th>
                <th>Max uses</th>
            </tr>
            <tr class="table-input-row">
                <td>
                    <div>
                        <input type="text" v-model="newVoucher.keycode" placeholder="Code"/>
                    </div>
                </td>
                <td>
                    <div>
                        <input type="number" v-model="newVoucher.data" placeholder="Value"/>
                        <select v-model="newVoucher.type">
                            <option value="percentage">%</option>
                            <option value="value">DKK</option>
                        </select>
                    </div>
                </td>
                <td>
                    <div>
                        <input type="text" v-model="newVoucher.description" placeholder="Description"/>
                    </div>
                </td>
                <td>
                    <div>
                        <input type="datetime-local" v-model="newVoucher.end_time" placeholder="Expiration date"/>
                    </div>
                </td>
                <td>
                    <div>
                        <input type="number" v-model="newVoucher.max_uses" placeholder="Max uses"/>
                    </div>
                </td>
            </tr>
        </table>
        <div class="action-panel">
            <div class="btn" v-on:click="generateCode()">Generate random code</div>
            <div class="btn" v-on:click="createVoucher()">Create</div>
        </div>
        <h2>Existing vouchers</h2>
        <table>
            <tr>
                <th>Code</th>
                <th>Value</th>
                <th>Description</th>
                <th>Time</th>
                <th>Uses</th>
                <th></th>
            </tr>
            <tr v-for="(voucher, index) in vouchers" :key="index">
                <td>{{voucher.keycode}}</td>
                <td>{{voucher.data}} <span v-if="voucher.type == 'percentage'">%</span><span v-if="voucher.type == 'value'">DKK</span></td>
                <td>{{voucher.description}}</td>
                <td>
                    <div class="flex-column">
                        <span>Created: {{dateTimeFormat(voucher.time)}}</span>
                        <span v-if="voucher.end_time != null">Expiration: {{dateTimeFormat(voucher.end_time)}}</span>
                    </div>
                </td>
                <td>{{voucher.uses}}/{{voucher.max_uses}}</td>
                <td width="87px">
                    <div class="action-panel sm column">
                        <div class="btn sm" v-on:click="printVoucherModal = index">Print</div>
                        <div class="btn sm" v-on:click="removeVoucherModal = index">Remove</div>
                    </div>
                </td>
            </tr>
            <tr v-if="vouchers.length == 0">
                <td colspan="6" class="no-result">No vouchers found</td>
            </tr>
        </table>
        <div class="modal" v-if="removeVoucherModal != -1">
            <div class="modal-body">
                <h3>Remove voucher</h3>
                <p>Are you sure you want to remove the voucher "{{vouchers[removeVoucherModal].keycode}}"?</p>
                <p>Voucher description: "{{vouchers[removeVoucherModal].description}}"</p>
                <div class="action-panel">
                    <div class="btn" v-on:click="removeVoucherModal = -1">Cancel</div>
                    <div class="btn main" v-on:click="deleteVoucher(vouchers[removeVoucherModal].id)">Yes</div>
                </div>
            </div>
        </div>
        <div class="modal" v-if="printVoucherModal != -1">
            <div class="modal-body">
                <div class="print-window">
                    <div class="title">
                        <span>Gift card</span>
                        <span>Use the code on</span>
                        <span>infrequent.dk</span>
                    </div>
                    <div class="data">
                        <span>Value:</span>
                        <p>
                            {{vouchers[printVoucherModal].data}} 
                            <span v-if="vouchers[printVoucherModal].type == 'percentage'">%</span>
                            <span v-if="vouchers[printVoucherModal].type == 'value'">DKK</span>
                        </p>

                        <span>Code:</span>
                        <p>{{vouchers[printVoucherModal].keycode}}</p>

                        <span>Expirationdate:</span>
                        <p>{{dateTimeFormat(vouchers[printVoucherModal].end_time)}}</p>
                    </div>
                    <p class="disclaimer">The gift card is not refundable</p>
                    <svg viewBox="0 0 640 512">
                        <path fill="currentColor" d="M240.6 194.1c1.9-30.8 17.3-61.2 44-79.8C279.4 103.5 268.7 96 256 96h-29.4l30.7-22c7.2-5.1 8.9-15.1 3.7-22.3l-9.3-13c-5.1-7.2-15.1-8.9-22.3-3.7l-32 22.9 11.5-30.6c3.1-8.3-1.1-17.5-9.4-20.6l-15-5.6c-8.3-3.1-17.5 1.1-20.6 9.4l-19.9 53-19.9-53.1C121 2.1 111.8-2.1 103.5 1l-15 5.6C80.2 9.7 76 19 79.2 27.2l11.5 30.6L58.6 35c-7.2-5.1-17.2-3.5-22.3 3.7l-9.3 13c-5.1 7.2-3.5 17.2 3.7 22.3l30.7 22H32c-17.7 0-32 14.3-32 32v352c0 17.7 14.3 32 32 32h168.9c-5.5-9.5-8.9-20.3-8.9-32V256c0-29.9 20.8-55 48.6-61.9zM224 480c0 17.7 14.3 32 32 32h160V384H224v96zm224 32h160c17.7 0 32-14.3 32-32v-96H448v128zm160-288h-20.4c2.6-7.6 4.4-15.5 4.4-23.8 0-35.5-27-72.2-72.1-72.2-48.1 0-75.9 47.7-87.9 75.3-12.1-27.6-39.9-75.3-87.9-75.3-45.1 0-72.1 36.7-72.1 72.2 0 8.3 1.7 16.2 4.4 23.8H256c-17.7 0-32 14.3-32 32v96h192V224h15.3l.7-.2.7.2H448v128h192v-96c0-17.7-14.3-32-32-32zm-272 0c-2.7-1.4-5.1-3-7.2-4.8-7.3-6.4-8.8-13.8-8.8-19 0-9.7 6.4-24.2 24.1-24.2 18.7 0 35.6 27.4 44.5 48H336zm199.2-4.8c-2.1 1.8-4.5 3.4-7.2 4.8h-52.6c8.8-20.3 25.8-48 44.5-48 17.7 0 24.1 14.5 24.1 24.2 0 5.2-1.5 12.6-8.8 19z" class="">
                    </path></svg>
                </div>



                <div class="action-panel">
                    <div class="btn" v-on:click="printVoucherModal = -1">Close</div>
                    <div class="btn main" v-on:click="print()">Print</div>
                </div>
            </div>
        </div>
    </div>
</template>
<style scoped lang="scss">
tr.table-input-row td div{
    display: flex;
    input:first-child{
        width: 0;
        flex-grow: 2;
        flex-shrink: 2;
    }
}
.print-window{
    transform: scale(0.5) translate(-50%, -50%);
    margin-bottom: -50%;
    width: calc(210mm - 1px);
    height: 148mm;
    background-color: #dcf4ff;
    color: black;
    overflow: hidden;
    background-image: linear-gradient(130deg, #81d4fa, #dcf4ff 70%);
    padding: 16px;
    position: relative;
    align-items: center;
    justify-content: space-between;
    display: flex;
    svg{
        position: absolute;
        bottom: -20px;
        right: -30px;
        width: 230px;
        color: rgba(#0277bd, 0.4);
        z-index: 0;
        transform: scale(-1, 1);
    }
    *:not(svg){
        z-index: 5;
    }
    .title{
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        flex-grow: 2;
        margin-right: 20px;
        span{
            font-weight: bold;
            &:nth-of-type(1){
                font-size: 40px;
                color: #01579b;
            }
        }
    }
    .data{
        width: 55%;
        border-left: 1px solid rgba(black, 0.3);
        padding-left: 20px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        color: black;
        p{
            font-weight: bold;
            margin: 0 0 10px 0;
            &:nth-of-type(1){
                font-size: 30px;
            }
            &:nth-of-type(2){
                font-size: 25px;
                color: #01579b;
            }
            &:nth-of-type(3){
                font-size: 16px;
                margin-bottom: 0;
            }
        }
        & > span{
            font-size: 14px;
        }
    }
    p.disclaimer{
        position: absolute;
        bottom: 10px;
        right: 0;
        left: 0;
        font-size: 12px;
        text-align: center;
        margin: 0;
    }
}
</style>
<script>
export default {
    name: 'Vouchers',
    data() {
        return {
            vouchers: [],
            newVoucher: {
                keycode: null,
                description: null,
                max_uses: null,
                time: null,
                end_time: null,
                type: 'value',
                data: null
            },
            removeVoucherModal: -1,
            printVoucherModal: -1,
        }
    },
    methods: {
        getVouchers: function(){
            var vue = this;
            this.$socket.client.emit('getVouchers',null, (error, response) => {
                if(error=='200'){
                    vue.vouchers = response;
                }
            })
        },
        dateTimeFormat: function(input){
            var date = new Date(input);
            return date.getDate() + ". " + this.$store.state.monthsShort[date.getMonth()] + " " + date.getFullYear() + " - " + ("0" + date.getHours()).slice(-2) + ":" + ("0" + date.getMinutes()).slice(-2) + ":" + ("0" + date.getSeconds()).slice(-2);
        },
        generateCode: function(){
            var text = "";
            var chars = "ABCDEFGHIJKLMNOPQRSTUVXYZ1234567890";
            for(var i = 0; i < 12; i++ ) {
                text += chars.charAt(Math.floor(Math.random() * chars.length));
                if(i == 3 || i == 7){
                    text += "-";
                }
            }
            this.newVoucher.keycode = text;
        },
        print: function(){
            window.print();
        },
        createVoucher: function(){
            if(this.newVoucher.keycode == null || this.newVoucher.keycode == ''){
                document.getElementById("Toast1").classList.remove("green");
                document.getElementById("Toast1").classList.remove("hide");
                document.getElementById("Toast1").classList.add("red");
                document.getElementById("Toast1").innerText = "Missing voucher code. Generate a random code";
                setTimeout(function() {
                    document.getElementById("Toast1").classList.add("hide");
                }, 3000);
                return;
            }
            if(this.newVoucher.data <= 0 || (this.newVoucher.type == 'percentage' && this.newVoucher.data >= 100)){
                document.getElementById("Toast1").classList.remove("green");
                document.getElementById("Toast1").classList.remove("hide");
                document.getElementById("Toast1").classList.add("red");
                document.getElementById("Toast1").innerText = "Voucher value incorect";
                setTimeout(function() {
                    document.getElementById("Toast1").classList.add("hide");
                }, 3000);
                return;
            }
            if(this.newVoucher.description == null || this.newVoucher.description == ''){
                document.getElementById("Toast1").classList.remove("green");
                document.getElementById("Toast1").classList.remove("hide");
                document.getElementById("Toast1").classList.add("red");
                document.getElementById("Toast1").innerText = "Missing voucher description";
                setTimeout(function() {
                    document.getElementById("Toast1").classList.add("hide");
                }, 3000);
                return;
            }
            if(this.newVoucher.end_time == null){
                document.getElementById("Toast1").classList.remove("green");
                document.getElementById("Toast1").classList.remove("hide");
                document.getElementById("Toast1").classList.add("red");
                document.getElementById("Toast1").innerText = "Missing voucher expiration date";
                setTimeout(function() {
                    document.getElementById("Toast1").classList.add("hide");
                }, 3000);
                return;
            }
            if(new Date(this.newVoucher.end_time) < new Date()){
                document.getElementById("Toast1").classList.remove("green");
                document.getElementById("Toast1").classList.remove("hide");
                document.getElementById("Toast1").classList.add("red");
                document.getElementById("Toast1").innerText = "Invalid expiration date has to be in the future";
                setTimeout(function() {
                    document.getElementById("Toast1").classList.add("hide");
                }, 3000);
                return;
            }
            if((new Date(this.newVoucher.end_time) - new Date()) > 63072000000){
                document.getElementById("Toast1").classList.remove("green");
                document.getElementById("Toast1").classList.remove("hide");
                document.getElementById("Toast1").classList.add("red");
                document.getElementById("Toast1").innerText = "Expiration date cannot be more than two years from now";
                setTimeout(function() {
                    document.getElementById("Toast1").classList.add("hide");
                }, 3000);
                return;
            }
            if(this.newVoucher.max_uses < 1){
                document.getElementById("Toast1").classList.remove("green");
                document.getElementById("Toast1").classList.remove("hide");
                document.getElementById("Toast1").classList.add("red");
                document.getElementById("Toast1").innerText = "Max uses should be more than zero";
                setTimeout(function() {
                    document.getElementById("Toast1").classList.add("hide");
                }, 3000);
                return;
            }

            var vue = this;
            this.$socket.client.emit('createVoucher',{
                keycode: vue.newVoucher.keycode,
                description: vue.newVoucher.description,
                max_uses: vue.newVoucher.max_uses,
                time: vue.newVoucher.time,
                end_time: vue.newVoucher.end_time,
                type: vue.newVoucher.type,
                data: vue.newVoucher.data},
                (error, response) => {
                if(error=='200'){
                   document.getElementById("Toast1").classList.remove("red");
                    document.getElementById("Toast1").classList.remove("hide");
                    document.getElementById("Toast1").classList.add("green");
                    document.getElementById("Toast1").innerText = "Voucher created";
                    setTimeout(function() {
                        document.getElementById("Toast1").classList.add("hide");
                    }, 3000);
                    vue.getVouchers();
                }else{
                    document.getElementById("Toast1").classList.remove("green");
                    document.getElementById("Toast1").classList.remove("hide");
                    document.getElementById("Toast1").classList.add("red");
                    document.getElementById("Toast1").innerText = "Voucher could not be created. Errorcode: " + response;
                    setTimeout(function() {
                        document.getElementById("Toast1").classList.add("hide");
                    }, 3000);
                }
            })
        }
    },
    mounted() {
        this.getVouchers();
    },
}
</script>